<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useTaskInfoHeader } from '../../model/info/task-info-header.hook'

defineOptions({
  name: 'TaskInfoHeader',
})

const {
  config,
} = useTaskInfoHeader()
</script>

<template>
  <NavigationBreadcrumbs
    :config="config"
  />
</template>